export const uiFilterVisibility = ['only_me', 'team'] as const;

export type UiFilterVisibility = (typeof uiFilterVisibility)[number];
